module.exports = __webpack_public_path__ + "img/eduDp.20e0c7ad.svg";